__turbopack_context__.v({
  "cta": "_56PxAG_cta",
  "ctaLink": "_56PxAG_ctaLink",
  "grid": "_56PxAG_grid",
  "header": "_56PxAG_header",
  "inner": "_56PxAG_inner",
  "section": "_56PxAG_section",
  "sectionCompact": "_56PxAG_sectionCompact",
  "title": "_56PxAG_title",
});
